import { render, staticRenderFns } from "./ReportPictureDetailsModal.vue?vue&type=template&id=64d0463c&scoped=true&"
import script from "./ReportPictureDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./ReportPictureDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPictureDetailsModal.vue?vue&type=style&index=0&id=64d0463c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0463c",
  null
  
)

export default component.exports